const NETEASE_URL =
  "https://cstaticdun.126.net/load.min.js" +
  "?t=" +
  getTimestamp(1 * 60 * 1000); // 时长1分钟，建议时长分钟级别

export const initNetease = (cb) => loadScript(NETEASE_URL, cb);

function getTimestamp(msec) {
  msec = !msec && msec !== 0 ? msec : 1;
  return parseInt(new Date().valueOf() / msec, 10);
}

export function loadScript(src, cb) {
  var head = document.head || document.getElementsByTagName("head")[0];
  var script = document.createElement("script");

  cb = cb || function () {};

  script.type = "text/javascript";
  script.src = src;

  if (!("onload" in script)) {
    // @ts-ignore
    script.onreadystatechange = function () {
      // @ts-ignore
      if (this.readyState !== "complete" && this.readyState !== "loaded") {
        return;
      }
      // @ts-ignore
      this.onreadystatechange = null;
      cb(script);
    };
  }

  script.onload = function () {
    this.onload = null;
    cb(script);
  };

  head.appendChild(script);
}
